import { Dialog, DialogActions, DialogContent, DialogTitle, Select, Grid, IconButton, MenuItem, FormControl } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'
import { AuthSessionContext } from "api/AuthSession"
import { useContext, useMemo } from "react"
import { Button } from "monday-ui-react-core"
import './UsersForm.scss'

const UpdateUsersRole = ({open, onClose, onSave, currentRole, newUserRoleId, setNewUserRoleId}) => {

    const { IS_OWNER, IS_ADMIN } = useContext(AuthSessionContext)

    const roleOptions = useMemo(() => {
        let options = []

        if (IS_OWNER) {
            options = [
                {value: 1, label: 'Admin'},
                {value: 2, label: 'Owner'},
                {value: 3, label: 'User'}
            ]
        } else if (IS_ADMIN) {
            options = [
                {value: 1, label: 'Admin'},
                {value: 3, label: 'User'}
            ]
        }

        return options.filter(value => value.label !== currentRole)
    }, [IS_OWNER, IS_ADMIN, currentRole])

    const handleRoleChange = (event) => {

        setNewUserRoleId(event.target.value)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={false}
                maxWidth='sm'
            >
                <DialogTitle>Update User Role</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <span>Please select the new role:</span>
                        </Grid>
                        <Grid item xs={12}>
                            <span>Current role: <b>{currentRole}</b></span>
                        </Grid>
                        <Grid item xs={12}>
                            <span>Select the new role: </span>
                            <FormControl sx={{ m: 1, minWidth: 120, marginTop: -1 }} size="small">
                                <Select
                                    value={newUserRoleId}
                                    onChange={handleRoleChange}
                                >
                                    {roleOptions.map(({value, label}, index) => {
                                        return (
                                            <MenuItem id={`item-${index}`} key={`item-${index}`} value={value}>{label}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel" onClick={onClose} marginRight={2}>Cancel</Button>
                    <Button className="success" onClick={onSave} marginRight={2}>Save</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default UpdateUsersRole